import { render } from "./ProductCardCompare.vue?vue&type=template&id=3f053956&ts=true&lang=pug"
import script from "./ProductCardCompare.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductCardCompare.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__